import MessageIcon from '@material-ui/icons/Message';
import MessagesList from './messagesList';
import MessagesShow from './messagesShow';

export default {
  list: MessagesList,
  show: MessagesShow,
  icon: MessageIcon,
};
